export enum NewsActionTypes {
  API_RESPONSE_SUCCESS = "@@news/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@news/API_RESPONSE_ERROR",

  CREATE_NEWS = "@@news/CREATE_NEWS",
  GET_NEWS = "@@news/GET_NEWS",
  UPDATE_NEWS = "@@news/UPDATE_NEWS",
  DELETE_NEWS = "@@news/DELETE_NEWS",
  DELETE_IMAGE = "@@news/DELETE_IMAGE",
}
